/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    OsisRuleFormDataTravelDateRestriction,
    OsisRuleFormDataTravelDateRestrictionFromJSON,
    OsisRuleFormDataTravelDateRestrictionFromJSONTyped,
    OsisRuleFormDataTravelDateRestrictionToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleFormData
 */
export interface OsisRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof OsisRuleFormData
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleFormData
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleFormData
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof OsisRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof OsisRuleFormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof OsisRuleFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleFormData
     */
    excludeAccountCodes?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleFormData
     */
    fareBasisCodes?: Array<string> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof OsisRuleFormData
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof OsisRuleFormData
     */
    marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleFormData
     */
    osIs?: Array<string> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof OsisRuleFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<OsisRuleFormDataTravelDateRestriction>}
     * @memberof OsisRuleFormData
     */
    travelDates?: Array<OsisRuleFormDataTravelDateRestriction> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof OsisRuleFormData
     */
    providers?: Array<GuidIdAndLabel> | null;
}

export function OsisRuleFormDataFromJSON(json: any): OsisRuleFormData {
    return OsisRuleFormDataFromJSONTyped(json, false);
}

export function OsisRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'excludeAccountCodes': !exists(json, 'excludeAccountCodes') ? undefined : json['excludeAccountCodes'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : json['fareBasisCodes'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'osIs': !exists(json, 'osIs') ? undefined : json['osIs'],
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(OsisRuleFormDataTravelDateRestrictionFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function OsisRuleFormDataToJSON(value?: OsisRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
        'allowEdit': value.allowEdit,
        'accountCodes': value.accountCodes,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'comment': value.comment,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'description': value.description,
        'disabled': value.disabled,
        'excludeAccountCodes': value.excludeAccountCodes,
        'fareBasisCodes': value.fareBasisCodes,
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'marketingCarriers': value.marketingCarriers === undefined ? undefined : (value.marketingCarriers === null ? null : (value.marketingCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'osIs': value.osIs,
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(OsisRuleFormDataTravelDateRestrictionToJSON)),
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


